import { render, staticRenderFns } from "./QScoreCardHqActive.vue?vue&type=template&id=19c66004&scoped=true&"
import script from "./QScoreCardHqActive.vue?vue&type=script&lang=js&"
export * from "./QScoreCardHqActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c66004",
  null
  
)

export default component.exports